module.exports = __webpack_public_path__ + "static/me-c4a51037b0b0af8e5e2f59351260b7d9.jpg";